export default __webpack_public_path__ + "static/whatsappPageHeroImg-99ff03e2fe13bf67f16d4816718e9a0d.png";